import { render, staticRenderFns } from "./TermoEmbargoIpaam.vue?vue&type=template&id=0a456b58&lang=pug"
import script from "./TermoEmbargoIpaam.vue?vue&type=script&lang=js"
export * from "./TermoEmbargoIpaam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports